import { I18n } from '@calendly/i18n'
import { CopyIcon } from '@calendly/ui/components/icons'
import { Item } from '@calendly/ui/components/menu'
import { get } from 'lodash-es'
import { useCallback } from 'react'

import { useSingleUseLinkSidebar } from '../hooks'
import { getSingleUseLinkEventTypeAttrs } from '../utils'

export const DuplicateMenuButton = ({ singleUseLink, trackMeetingInteraction = () => {} }) => {
  const { openSidebar } = useSingleUseLinkSidebar()

  const onClick = useCallback(() => {
    const shareOverrides = get(singleUseLink, 'share.shareOverride') || {}
    const eventType = get(singleUseLink, 'share.eventType') || {}
    const name = shareOverrides.name || eventType.name

    trackMeetingInteraction()
    openSidebar({
      selectedEventTypeAttrs: getSingleUseLinkEventTypeAttrs(get(singleUseLink, 'share.eventType', null)),
      singleUseLinkAttrs: {
        shareOverrideName: `${name} (${I18n.t('publisher.labels.cloned_suffix')})`,
        shareUuid: singleUseLink.share.uuid,
      },
      isCreation: true
    })
  }, [openSidebar, singleUseLink, trackMeetingInteraction])

  return (
    <Item onClick={onClick} role="menuitem">
      <CopyIcon />
      {I18n.t('publisher.action.duplicate')}
    </Item>
  )
}
